import {useLocation, useParams} from "react-router-dom";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {constantsErrorMessages} from "../../../Constants";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {Button, Checkbox, Typography} from "@mui/material";
import RichTextEditor from "../../../components/UI/RichTextEditor";
import {ButtonGroupTabBar} from "../../../components/UI/button/ButtonGroupTabBar";
import CheckIcon from "@mui/icons-material/Check";

import TextFieldValidation from "../../../components/UI/table/customer-detales/TextFieldValidation";
import MenuItem from "@mui/material/MenuItem";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import {replaceEmptyStringsOnNull} from "../../../utils/ReplaceEmptyStringsOnNull";
import CircularProgress from "@mui/material/CircularProgress";
import CompositionController from "../../../API/organization/CompositionController";
import {cornerTypeModule} from "../../../data/CornerTypeModule";
import {typeCompositionModule} from "../../../data/TypeCompositionModule";
import FormControlLabel from "@mui/material/FormControlLabel";
import ButtonBlue from "../../../components/UI/button/ButtonBlue";
import {withFilter} from "../../../data/FilterTables/withFilterHOC";
import CompositionModuleTable from "./CompositionModuleTable";
import {CompositionModuleFilterData} from "../../../data/FilterTables/CompositionModuleFilterData";
import IconButton from "@mui/material/IconButton";
import {ReactComponent as PencilIcon} from "../../../components/Icons/pencil.svg"
import ModalEditMaterial from "../../../components/UI/modal/ModalEditMaterial";
import {applyMediaDependentMocks} from "../../../dev/applyMediaDependentMocks";
import {isRichTextEqual, normalizeRichText, parseDescriptionFromApi} from "../../../utils/richTextUtils";
import {fetchCompositionPicturesWithUrls} from "../../../utils/getCompositionPictures";
import {
    getModuleRowsFromCompositionPayload,
    pickCompositionRecalculatedDimensions,
} from "../../../utils/compositionMediaUtils";
import {rememberKitchenCompositionId} from "../../../utils/withCompositionIdQuery";
import CompositionSettingsMedia from "./CompositionSettingsMedia";
import CompositionReplacementsTable from "./CompositionReplacementsTable";
import Composition3DView from "./Composition3DView";
import CompositionMainTextureSelect from "./CompositionMainTextureSelect";
import UtilityServiceOrganizationPictures from "../../../API/common/UtilityServiceOrganizationPictures";
import {
    COMPOSITION_TEXTURE_SLOTS,
    pickCompositionTextureIdsFromComposition,
} from "../../../utils/compositionTextureAssignment";
import {
    isMockTextureId,
    withTextureCatalogFallback,
} from "../../../utils/mockCompositionTextureCatalog";


const initValidation = {
    "name": "",
}
const ModulesItem = () => {
    const CompositionModuleWithFilter = useMemo(() => {
        return withFilter(CompositionModuleTable, CompositionModuleFilterData);
    }, []);
    const cornerTypeModuleList = Object.entries(cornerTypeModule)
    const typeCompositionModuleList = Object.entries(typeCompositionModule)
    const params = useParams();
    const pathname = useLocation().pathname
    const [loading, setLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    const [data, setData] = useState({
        "name": "",
        "shortDescription": "",
        "cornerType": cornerTypeModuleList[0][0],
        "typeComposition": typeCompositionModuleList[0][0],
        "price": null,
        "alternativePrice": null,
        "discountAmount": null,
        "top": false,
        "discount": false,
        "typeBodyTop": null,
        "nameShortBodyTop": null,
        "typeBodyBottom": null,
        "nameShortBodyBottom": null,
        "typeFrontTop": null,
        "nameShortFrontTop": null,
        "typeFrontBottom": null,
        "nameShortFrontBottom": null,
        "nameBackTop": null,
        "typeBackTop": null,
        "nameShortBackTop": null,
        "backTopMaterialId": null,
        "nameBackBottom": null,
        "typeBackBottom": null,
        "nameShortBackBottom": null,
        "backBottomMaterialId": null,
        "typeTableTop": null,
        "nameShortTableTop": null,
        "minLengthLeft": null,
        "minLengthRight": null,
        "maxLengthLeft": null,
        "maxLengthRight": null,
        "countertopCuttingTreatment": null,
        "typeWallPanel": null,
        "nameShortWallPanel": null,
        "collection": null,
        "colorScheme": null
    });


    const [validationState, setValidationState] = useState(initValidation)
    const [moduleName, setModuleName] = useState("")
    const [description, setDescription] = useState("")
    const [moduleCompositions, setModuleCompositions] = useState([])
    const [newDescription, setNewDescription] = useState("")
    const [alertData, setAlertData] = useState({});
    const [tab, setTab] = useState(() => {
        const pagesData = JSON.parse(localStorage.getItem("pagesData") || "{}");
        const saved = Number(pagesData[pathname]?.tab);
        return Number.isFinite(saved) && saved >= 1 ? saved : 1;
    });
    const [open, setOpen] = useState(false)
    const [modalMaterialData, setModalMaterialData] = useState({
        subTypeMaterial: null,
        materialName: null,
        materialId: null
    })
    const [textureCatalog, setTextureCatalog] = useState([])
    /** Поля слотов, для которых сейчас идёт set-texture (параллельно, не блокируя соседние). */
    const [textureSavingByField, setTextureSavingByField] = useState({})
    const textureSavingFieldsRef = useRef(new Set())
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        if (typeof nextState === "function") {
            setTableOptions((prev) => {
                const resolved = nextState(prev)
                if (resolved?.pageSize != null && resolved.pageSize !== prev.pageSize) {
                    EditLocalStoragePagesData(`${pathname}`, "pageSize", resolved.pageSize)
                }
                return resolved ?? prev
            })
            return
        }
        if (nextState == null) {
            return
        }
        setTableOptions(nextState)
        if (nextState.pageSize != null && nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}`, "pageSize", nextState.pageSize)
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem("pagesData") || {});
        const savedTab = Number(pagesData[pathname]?.tab);
        return {savedTab: Number.isFinite(savedTab) && savedTab >= 1 ? savedTab : 1};
    };

    useEffect(() => {
        rememberKitchenCompositionId(params.id)
    }, [params.id])

    useEffect(() => {
        setModuleCompositions([])
        const {savedTab} = getStartPageSize()
        let cancelled = false

        CompositionController.getById(params.id)
            .then(async function (response) {
                if (cancelled) {
                    return
                }
                const {
                    moduleCompositions: _orgModuleCompositions,
                    mediaId,
                    description,
                    pictures: orgPictures,
                    ...rest
                } = response.data
                const modules = getModuleRowsFromCompositionPayload(response.data)
                const modulesForUi = applyMediaDependentMocks(modules) ?? []
                const moduleRows = Array.isArray(modulesForUi) ? modulesForUi : []
                const pictures = await fetchCompositionPicturesWithUrls(mediaId, orgPictures)
                if (cancelled) {
                    return
                }
                setModuleCompositions(moduleRows)
                tableOptionsHandle((prev) => ({
                    ...prev,
                    totalElements: moduleRows.length,
                }))
                setData({
                    ...rest,
                    mediaId,
                    pictures,
                })
                setModuleName(rest.name)
                const parsedDescription = parseDescriptionFromApi(description)
                setDescription(parsedDescription)
                setNewDescription(parsedDescription)
                setTab(savedTab)
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(function () {
                if (!cancelled) {
                    setIsLoading(false)
                }
            })

        return () => {
            cancelled = true
        }
    }, [params.id]);

    useEffect(() => {
        if (tab !== 1) {
            return undefined;
        }
        let cancelled = false;
        UtilityServiceOrganizationPictures.getAllTextured()
            .then((response) => {
                if (cancelled) {
                    return;
                }
                const list = Array.isArray(response?.data) ? response.data : [];
                const {rows} = withTextureCatalogFallback(list);
                setTextureCatalog(rows);
            })
            .catch((error) => {
                if (!cancelled) {
                    const {rows} = withTextureCatalogFallback([]);
                    setTextureCatalog(rows);
                    handleModalAlert(error);
                }
            });
        return () => {
            cancelled = true;
        };
    }, [params.id, tab]);

    useEffect(() => {
        setTextureCatalog([]);
    }, [params.id]);

    const compositionTexturesForScene = useMemo(
        () => pickCompositionTextureIdsFromComposition(data),
        [data],
    );

    const handleCompositionTextureChange = useCallback((slot, textureId) => {
        if (!slot) {
            return;
        }
        const field = slot.textureIdField;
        if (textureSavingFieldsRef.current.has(field)) {
            return;
        }
        textureSavingFieldsRef.current.add(field);
        setTextureSavingByField((prev) => ({...prev, [field]: true}));

        const clearSaving = () => {
            textureSavingFieldsRef.current.delete(field);
            setTextureSavingByField((prev) => {
                if (!prev[field]) {
                    return prev;
                }
                const next = {...prev};
                delete next[field];
                return next;
            });
        };

        const applyLocal = () => {
            setData((prev) => ({...prev, [field]: textureId}));
            handleModalAlert("Данные изменены", "success");
        };

        // Mock-пул: id отрицательные, бэк set-texture их не принимает — только локальный state для 3D.
        if (textureId != null && isMockTextureId(textureId)) {
            applyLocal();
            clearSaving();
            return;
        }

        CompositionController.setTexture(params.id, slot.compositionMaterialType, textureId)
            .then(() => {
                applyLocal();
            })
            .catch((error) => {
                handleModalAlert(error);
            })
            .finally(() => {
                clearSaving();
            });
    }, [params.id]);

    const renderCompositionTextureFields = () => (
        COMPOSITION_TEXTURE_SLOTS.map((slot) => (
            <CompositionMainTextureSelect
                key={slot.textureIdField}
                textureIdField={slot.textureIdField}
                label={slot.label}
                value={data?.[slot.textureIdField]}
                options={textureCatalog}
                loading={Boolean(textureSavingByField[slot.textureIdField])}
                onChange={(textureId) => handleCompositionTextureChange(slot, textureId)}
            />
        ))
    );

    const handleChangeTab = (tab) => {
        setTab(tab)
        EditLocalStoragePagesData(pathname, "tab", tab)
    }

    const handleCloseAlert = () => {
        setAlertData((alert) => {
            return {...alert, open: false}
        })
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    const setPacedModuleByKey = (moduleKey, pacedModule) => {
        setModuleCompositions((prev) => prev.map((row, index) => {
            const key = row?.id
                ?? row?.moduleCompositionId
                ?? row?.moduleId
                ?? row?.module?.id
                ?? `composition-module-${index}`;
            if (String(key) !== String(moduleKey)) return row;
            return {
                ...row,
                pacedModule: pacedModule ?? null,
            };
        }));
    };

    const reloadCompositionModules = useCallback(() => {
        return CompositionController.getById(params.id)
            .then((response) => {
                const modules = getModuleRowsFromCompositionPayload(response.data);
                setModuleCompositions(applyMediaDependentMocks(modules) ?? []);
                const dimensionPatch = pickCompositionRecalculatedDimensions(response.data);
                if (Object.keys(dimensionPatch).length > 0) {
                    setData((prev) => ({...prev, ...dimensionPatch}));
                }
            });
    }, [params.id]);

    const handleUpdate = () => {
        setLoading(true)
        const {
            lengthLeft,
            lengthLeftTableTop,
            lengthLeftTop,
            lengthRight,
            lengthRightTableTop,
            lengthRightTop,
            ...rest
        } = data
        const payload = replaceEmptyStringsOnNull({
            ...rest,
            minLengthLeft: rest.minLengthLeft == null || rest.minLengthLeft === ""
                ? null
                : Number(rest.minLengthLeft),
            minLengthRight: rest.minLengthRight == null || rest.minLengthRight === ""
                ? null
                : Number(rest.minLengthRight),
            maxLengthLeft: rest.maxLengthLeft == null || rest.maxLengthLeft === ""
                ? null
                : Number(rest.maxLengthLeft),
            maxLengthRight: rest.maxLengthRight == null || rest.maxLengthRight === ""
                ? null
                : Number(rest.maxLengthRight),
        })
        CompositionController.edit(payload, rest.id)
            .then(function (response) {
                setData({...data, ...response.data})
                setModuleName(response.data.name)
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }
    const handleDescription = () => {
        const payload = normalizeRichText(newDescription)
        setLoading(true)
        CompositionController.description(payload, params.id)
            .then(function (response) {
                setDescription(payload)
                setNewDescription(payload)
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }
    const handleValidationData = () => {
        const newErrors = {...validationState}

        Object.entries(data).forEach(([name, value]) => {

            if (value === "" && name !== "groupName") {
                newErrors[name] = "пустое поле"
            }
        })

        setValidationState(newErrors)

        if (Object.values(newErrors).every(el => el === "")) {
            handleUpdate()
        }
    }
    const handleClose = () => {
        setModalMaterialData({subTypeMaterial: null, materialId: null, materialName: null})
        setOpen(false)
    }
    const handleSubmit = (value, handleClose) => {
        const {field1, field2} = value.type

        if (field1 === "nameBackTop" || field1 === "nameBackBottom") {
            setData((prev) => ({
                ...prev,
                [field1]: value.materialName,
                [field2]: value.materialId,
            }))
            handleClose()
            return
        }

        const api = field1 === "nameTableTop" ? CompositionController.setTableTop :
            field1 === "nameWallPanel" ? CompositionController.setWallPanel :
                field1 === "nameFrontTop" ? CompositionController.setFrontTop :
                    field1 === "nameFrontBottom" ? CompositionController.setFrontBottom :
                        field1 === "nameBodyTop" ? CompositionController.setBodyTop :
                            CompositionController.setBodyBottom

        api(params.id, value.materialName, value.materialId)
            .then(function () {
                setData({...data, [field1]: value.materialName, [field2]: value.materialId})
                handleModalAlert("Данные изменены", 'success')
                handleClose()
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const renderMaterialGroup = ({
                                     nameField,
                                     typeField,
                                     shortNameField,
                                     materialIdField,
                                     materialLabel,
                                     typeLabel,
                                     shortNameLabel,
                                     subTypeMaterial,
                                 }) => (
        <>
            <TextFieldValidation
                name={nameField}
                value={data?.[nameField] || ''}
                label={materialLabel}
                required={false}
                disabled={true}
                adornment={<IconButton
                    onClick={() => {
                        setOpen(true)
                        setModalMaterialData({
                            subTypeMaterial,
                            materialId: data?.[materialIdField],
                            materialName: data?.[nameField],
                            type: {field1: nameField, field2: materialIdField},
                        })
                    }}
                >
                    <PencilIcon/>
                </IconButton>}
            />
            <TextFieldValidation
                name={typeField}
                value={data?.[typeField]}
                label={typeLabel}
                setCurrValues={setData}
                required={false}
            />
            <TextFieldValidation
                name={shortNameField}
                value={data?.[shortNameField]}
                label={shortNameLabel}
                setCurrValues={setData}
                required={false}
            />
        </>
    )
    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`Композиция ${moduleName}`}
                path={[{name: "Главная", href: "/"}, {name: "Настройки", href: "/settings"}]}/>
            <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
                <Typography sx={{fontSize: "24px", fontWeight: 700}}>{`Композиция ${moduleName}`}</Typography>
                <ButtonGroupTabBar activeTab={tab}>
                    <Button tabIndex={1} onClick={() => handleChangeTab(1)}>
                        <CheckIcon/>
                        Основные
                    </Button>
                    <Button tabIndex={2} onClick={() => handleChangeTab(2)}>
                        <CheckIcon/>
                        Модули
                    </Button>
                    <Button tabIndex={3} onClick={() => handleChangeTab(3)}>
                        <CheckIcon/>
                        Медиа
                    </Button>
                    <Button tabIndex={4} onClick={() => handleChangeTab(4)}>
                        <CheckIcon/>
                        Сцена 3д
                    </Button>
                    <Button tabIndex={5} onClick={() => handleChangeTab(5)}>
                        <CheckIcon/>
                        Полное описание
                    </Button>
                </ButtonGroupTabBar>
                {isLoading ?
                    <Box sx={{
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <CircularProgress disableShrink/>
                    </Box> : <>
                        {tab === 1 ? <Box sx={{display: "flex", gap: "20px"}}>
                            <Box sx={{width: "400px"}}>
                                <TextFieldValidation
                                    name={"name"}
                                    type={"text"}
                                    value={data?.name}
                                    label={"Наименование"}
                                    setCurrValues={setData}
                                    validationError={validationState?.name}
                                    setValidationState={setValidationState}
                                />
                                <TextFieldValidation
                                    name={"shortDescription"}
                                    type={"text"}
                                    value={data?.shortDescription}
                                    label={"Описание"}
                                    setCurrValues={setData}
                                    required={false}
                                />

                                <TextFieldValidation
                                    select
                                    label="Тип композиции"
                                    value={data?.typeComposition}
                                    setCurrValues={(getData) => setData(prev => ({
                                        ...prev,
                                        typeComposition: getData()
                                    }))}
                                    width={"400px"}
                                    required={false}
                                >
                                    {typeCompositionModuleList?.map((option) => (
                                        <MenuItem key={option[0]} value={option[0]}>
                                            {option[1]}
                                        </MenuItem>
                                    ))}
                                </TextFieldValidation>
                                <TextFieldValidation
                                    select
                                    label="Тип кухни по расположению"
                                    value={data?.cornerType}
                                    setCurrValues={(getData) => setData(prev => ({
                                        ...prev,
                                        cornerType: getData()
                                    }))}
                                    width={"400px"}
                                    required={false}
                                    disabled={data?.typeComposition !== "KITCHEN"}
                                >
                                    {cornerTypeModuleList?.map((option) => (
                                        <MenuItem key={option[0]} value={option[0]}>
                                            {option[1]}
                                        </MenuItem>
                                    ))}
                                </TextFieldValidation>
                                <TextFieldValidation
                                    name={"lengthLeft"}
                                    type={"number"}
                                    value={data?.lengthLeft}
                                    label={"Длина слева"}
                                    setCurrValues={setData}
                                    disabled={true}
                                />
                                <TextFieldValidation
                                    name={"lengthRight"}
                                    type={"number"}
                                    value={data?.lengthRight}
                                    label={"Длина справа"}
                                    setCurrValues={setData}
                                    disabled={true}
                                />
                                <TextFieldValidation
                                    name={"lengthLeftTop"}
                                    type={"number"}
                                    value={data?.lengthLeftTop}
                                    label={"Длина слева сверху"}
                                    setCurrValues={setData}
                                    disabled={true}
                                />
                                <TextFieldValidation
                                    name={"lengthRightTop"}
                                    type={"number"}
                                    value={data?.lengthRightTop}
                                    label={"Длина справа сверху"}
                                    setCurrValues={setData}
                                    disabled={true}
                                />
                                <TextFieldValidation
                                    name={"lengthLeftTableTop"}
                                    type={"number"}
                                    value={data?.lengthLeftTableTop}
                                    label={"Длина слева по столешнице"}
                                    setCurrValues={setData}
                                    disabled={true}
                                />
                                <TextFieldValidation
                                    name={"lengthRightTableTop"}
                                    type={"number"}
                                    value={data?.lengthRightTableTop}
                                    label={"Длина справа по столешнице"}
                                    setCurrValues={setData}
                                    disabled={true}
                                />
                                <TextFieldValidation
                                    name={"collection"}
                                    value={data?.collection}
                                    label={"Коллекция"}
                                    setCurrValues={setData}
                                    required={false}
                                />
                                <TextFieldValidation
                                    name={"colorScheme"}
                                    value={data?.colorScheme}
                                    label={"Название расцветки"}
                                    setCurrValues={setData}
                                    required={false}
                                />
                                <TextFieldValidation
                                    name={"countertopCuttingTreatment"}
                                    value={data?.countertopCuttingTreatment}
                                    label={"Обработка среза столешницы"}
                                    setCurrValues={setData}
                                    required={false}
                                />
                                <TextFieldValidation
                                    name={"price"}
                                    type={"number"}
                                    value={data?.price}
                                    label={"Цена"}
                                    setCurrValues={setData}
                                    validationError={validationState?.price}
                                    setValidationState={setValidationState}
                                />
                                <TextFieldValidation
                                    name={"alternativePrice"}
                                    type={"number"}
                                    value={data?.alternativePrice}
                                    label={"Цена в альтернативной валюте"}
                                    setCurrValues={setData}
                                />
                                <FormControlLabel control={<Checkbox
                                    checked={data?.top}
                                    onChange={() => setData(value => ({
                                        ...value,
                                        "top": !value.top
                                    }))}
                                    sx={{marginLeft: "20px"}}
                                />} label="Популярное"/>
                                <FormControlLabel control={<Checkbox
                                    checked={data?.discount}
                                    onChange={() => setData(value => ({
                                        ...value,
                                        "discount": !value.discount
                                    }))}
                                    sx={{marginLeft: "20px"}}
                                />} label="Скидка"/>
                                <TextFieldValidation
                                    name={"discountAmount"}
                                    type={"number"}
                                    value={data?.discountAmount}
                                    label={"Сумма скидки"}
                                    setCurrValues={setData}
                                    disabled={!data?.discount}
                                />
                            </Box>
                            <Box sx={{
                                width: "820px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between"
                            }}>
                                <Box sx={{
                                    display: "grid",
                                    gridTemplateColumns: "400px 400px",
                                    columnGap: "20px",
                                    alignItems: "start",
                                }}>
                                    <Box sx={{gridColumn: 2, gridRow: 4}}>
                                    <TextFieldValidation
                                        name={"nameWallPanel"}
                                        value={data?.nameWallPanel || ''}
                                        label={"Материал стеновой панели"}
                                        required={false}
                                        disabled={true}
                                        adornment={<IconButton
                                            onClick={() => {
                                                setOpen(true)
                                                setModalMaterialData({
                                                    subTypeMaterial: "WALL_PANEL",
                                                    materialId: data.wallPanelMaterialId,
                                                    materialName: data.nameWallPanel,
                                                    type: {field1: "nameWallPanel", field2: "wallPanelMaterialId"},
                                                })
                                            }
                                            }
                                        >
                                            {<PencilIcon/>}
                                        </IconButton>}
                                    />
                                    <TextFieldValidation
                                        name={"typeWallPanel"}
                                        value={data?.typeWallPanel}
                                        label={"Тип стеновой панели"}
                                        setCurrValues={setData}
                                        required={false}
                                    />
                                    <TextFieldValidation
                                        name={"nameShortWallPanel"}
                                        value={data?.nameShortWallPanel}
                                        label={"Наименование стеновой панели"}
                                        setCurrValues={setData}
                                        required={false}
                                    />
                                    </Box>

                                    <Box sx={{gridColumn: 1, gridRow: 1}}>
                                    <TextFieldValidation
                                        name={"nameBodyTop"}
                                        value={data?.nameBodyTop || ''}
                                        label={"Материал верха корпуса"}
                                        required={false}
                                        disabled={true}
                                        adornment={<IconButton
                                            onClick={() => {
                                                setOpen(true)
                                                setModalMaterialData({
                                                    subTypeMaterial: "SHEET",
                                                    materialId: data.bodyTopMaterialId,
                                                    materialName: data.nameBodyTop,
                                                    type: {field1: "nameBodyTop", field2: "bodyTopMaterialId"},
                                                })
                                            }
                                            }
                                        >
                                            {<PencilIcon/>}
                                        </IconButton>}
                                    />
                                    <TextFieldValidation
                                        name={"typeBodyTop"}
                                        value={data?.typeBodyTop}
                                        label={"Тип верха корпуса"}
                                        setCurrValues={setData}
                                        required={false}
                                    />
                                    <TextFieldValidation
                                        name={"nameShortBodyTop"}
                                        value={data?.nameShortBodyTop}
                                        label={"Наименование верха корпуса"}
                                        setCurrValues={setData}
                                        required={false}
                                    />
                                    </Box>

                                    <Box sx={{gridColumn: 2, gridRow: 1}}>
                                    <TextFieldValidation
                                        name={"nameBodyBottom"}
                                        value={data?.nameBodyBottom || ''}
                                        label={"Материал низа корпуса"}
                                        required={false}
                                        disabled={true}
                                        adornment={<IconButton
                                            onClick={() => {
                                                setOpen(true)
                                                setModalMaterialData({
                                                    subTypeMaterial: "SHEET",
                                                    materialId: data.bodyBottomMaterialId,
                                                    materialName: data.nameBodyBottom,
                                                    type: {field1: "nameBodyBottom", field2: "bodyBottomMaterialId"},
                                                })
                                            }
                                            }
                                        >
                                            {<PencilIcon/>}
                                        </IconButton>}
                                    />
                                    <TextFieldValidation
                                        name={"typeBodyBottom"}
                                        value={data?.typeBodyBottom}
                                        label={"Тип низа корпуса"}
                                        setCurrValues={setData}
                                        required={false}
                                    />
                                    <TextFieldValidation
                                        name={"nameShortBodyBottom"}
                                        value={data?.nameShortBodyBottom}
                                        label={"Наименование низа корпуса"}
                                        setCurrValues={setData}
                                        required={false}
                                    />
                                    </Box>
                                    <Box sx={{gridColumn: 1, gridRow: 2}}>
                                    <TextFieldValidation
                                        name={"nameFrontTop"}
                                        value={data?.nameFrontTop || ''}
                                        label={"Материал верха фасада"}
                                        required={false}
                                        disabled={true}
                                        adornment={<IconButton
                                            onClick={() => {
                                                setOpen(true)
                                                setModalMaterialData({
                                                    subTypeMaterial: "SHEET",
                                                    materialId: data.bodyFrontMaterialId,
                                                    materialName: data.nameFrontTop,
                                                    type: {field1: "nameFrontTop", field2: "bodyFrontMaterialId"},
                                                })
                                            }
                                            }
                                        >
                                            {<PencilIcon/>}
                                        </IconButton>}
                                    />
                                    <TextFieldValidation
                                        name={"typeFrontTop"}
                                        value={data?.typeFrontTop}
                                        label={"Тип верха фасада"}
                                        setCurrValues={setData}
                                        required={false}
                                    />
                                    <TextFieldValidation
                                        name={"nameShortFrontTop"}
                                        value={data?.nameShortFrontTop}
                                        label={"Наименование верха фасада"}
                                        setCurrValues={setData}
                                        required={false}
                                    />
                                    </Box>

                                    <Box sx={{gridColumn: 2, gridRow: 2}}>
                                    <TextFieldValidation
                                        name={"nameFrontBottom"}
                                        value={data?.nameFrontBottom || ''}
                                        label={"Материал низа фасада"}
                                        required={false}
                                        disabled={true}
                                        adornment={<IconButton
                                            onClick={() => {
                                                setOpen(true)
                                                setModalMaterialData({
                                                    subTypeMaterial: "SHEET",
                                                    materialId: data.frontBottomMaterialId,
                                                    materialName: data.nameFrontBottom,
                                                    type: {field1: "nameFrontBottom", field2: "frontBottomMaterialId"},
                                                })
                                            }
                                            }
                                        >
                                            {<PencilIcon/>}
                                        </IconButton>}
                                    />
                                    <TextFieldValidation
                                        name={"typeFrontBottom"}
                                        value={data?.typeFrontBottom}
                                        label={"Тип низа фасада"}
                                        setCurrValues={setData}
                                        required={false}
                                    />
                                    <TextFieldValidation
                                        name={"nameShortFrontBottom"}
                                        value={data?.nameShortFrontBottom}
                                        label={"Наименование низа фасада"}
                                        setCurrValues={setData}
                                        required={false}
                                    />
                                    </Box>
                                    <Box sx={{gridColumn: 1, gridRow: 4}}>
                                    <TextFieldValidation
                                        name={"nameTableTop"}
                                        value={data?.nameTableTop || ''}
                                        label={"Материал верха столешницы"}
                                        required={false}
                                        disabled={true}
                                        adornment={<IconButton
                                            onClick={() => {
                                                setOpen(true)
                                                setModalMaterialData({
                                                    subTypeMaterial: "TABLETOP",
                                                    materialId: data.tableTopMaterialId,
                                                    materialName: data.nameTableTop,
                                                    type: {field1: "nameTableTop", field2: "tableTopMaterialId"},
                                                })
                                            }
                                            }
                                        >
                                            {<PencilIcon/>}
                                        </IconButton>}
                                    />
                                    <TextFieldValidation
                                        name={"typeTableTop"}
                                        value={data?.typeTableTop}
                                        label={"Тип верха столешницы"}
                                        setCurrValues={setData}
                                        required={false}
                                    />
                                    <TextFieldValidation
                                        name={"nameShortTableTop"}
                                        value={data?.nameShortTableTop}
                                        label={"Наименование верха столешницы"}
                                        setCurrValues={setData}
                                        required={false}
                                    />
                                    </Box>
                                    <Box sx={{gridColumn: 1, gridRow: 3}}>
                                        {renderMaterialGroup({
                                            nameField: "nameBackTop",
                                            typeField: "typeBackTop",
                                            shortNameField: "nameShortBackTop",
                                            materialIdField: "backTopMaterialId",
                                            materialLabel: "Материал верха задней стенки",
                                            typeLabel: "Тип верха задней стенки",
                                            shortNameLabel: "Наименование верха задней стенки",
                                            subTypeMaterial: "SHEET",
                                        })}
                                    </Box>
                                    <Box sx={{gridColumn: 2, gridRow: 3}}>
                                        {renderMaterialGroup({
                                            nameField: "nameBackBottom",
                                            typeField: "typeBackBottom",
                                            shortNameField: "nameShortBackBottom",
                                            materialIdField: "backBottomMaterialId",
                                            materialLabel: "Материал низа задней стенки",
                                            typeLabel: "Тип низа задней стенки",
                                            shortNameLabel: "Наименование низа задней стенки",
                                            subTypeMaterial: "SHEET",
                                        })}
                                    </Box>
                                    <Box sx={{gridColumn: 1, gridRow: 5}}>
                                        <TextFieldValidation
                                            name={"minLengthLeft"}
                                            type={"number"}
                                            value={data?.minLengthLeft}
                                            label={"Минимальная длина слева"}
                                            setCurrValues={setData}
                                            required={false}
                                        />
                                        <TextFieldValidation
                                            name={"maxLengthLeft"}
                                            type={"number"}
                                            value={data?.maxLengthLeft}
                                            label={"Максимальная длина слева"}
                                            setCurrValues={setData}
                                            required={false}
                                        />
                                    </Box>
                                    <Box sx={{gridColumn: 2, gridRow: 5}}>
                                        <TextFieldValidation
                                            name={"minLengthRight"}
                                            type={"number"}
                                            value={data?.minLengthRight}
                                            label={"Минимальная длина справа"}
                                            setCurrValues={setData}
                                            required={false}
                                        />
                                        <TextFieldValidation
                                            name={"maxLengthRight"}
                                            type={"number"}
                                            value={data?.maxLengthRight}
                                            label={"Максимальная длина справа"}
                                            setCurrValues={setData}
                                            required={false}
                                        />
                                    </Box>
                                </Box>
                                <Box
                                    sx={{
                                        display: "grid",
                                        gridTemplateColumns: "400px 400px",
                                        columnGap: "20px",
                                        alignItems: "start",
                                        width: 820,
                                    }}
                                >
                                    {renderCompositionTextureFields()}
                                </Box>
                                <Box sx={{
                                    width: 820,
                                    paddingTop: "20px",
                                    display: "flex",
                                    justifyContent: data ? "flex-end" : "flex-start"
                                }}>
                                    <ButtonAdd loading={loading} text={"Применить"} onClick={handleValidationData}/>
                                </Box>
                            </Box>

                        </Box> : tab === 2 ? (
                            <Box sx={{display: "flex", flexDirection: "column", width: "100%"}}>
                            <CompositionModuleWithFilter
                                data={moduleCompositions}
                                setData={setModuleCompositions}
                                tableOptions={tableOptions}
                                tableOptionsHandle={tableOptionsHandle}
                                handleModalAlert={handleModalAlert}
                                compositionId={params.id}
                                compositionName={data.name}
                            />
                            <CompositionReplacementsTable
                                compositionId={params.id}
                                handleModalAlert={handleModalAlert}
                            />
                            </Box>
                        ) : tab === 3 ? (
                            <CompositionSettingsMedia
                                compositionId={params.id}
                                data={data}
                                moduleCompositions={moduleCompositions}
                                setModuleCompositions={setModuleCompositions}
                                handleModalAlert={handleModalAlert}
                            />
                        ) : tab === 4 ? (
                            <Composition3DView
                                compositionId={params.id}
                                compositionName={data.name}
                                moduleCompositions={moduleCompositions}
                                setModuleCompositions={setModuleCompositions}
                                compositionLengthLeft={data?.lengthLeft}
                                compositionLengthRight={data?.lengthRight}
                                compositionHeight={data?.height}
                                compositionCornerType={data?.cornerType}
                                compositionTextures={compositionTexturesForScene}
                                onPacedModuleChange={setPacedModuleByKey}
                                onReloadModuleCompositions={reloadCompositionModules}
                                handleModalAlert={handleModalAlert}
                            />
                        ) : tab === 5 ? (
                            <Box sx={{display: "flex", maxWidth: 900}}>
                                <Box sx={{flex: 1, minWidth: 560}}>
                                    <RichTextEditor
                                        value={newDescription}
                                        onChange={setNewDescription}
                                        minHeight={400}
                                    />
                                </Box>
                                <Box sx={{
                                    paddingLeft: "20px",
                                    display: "flex",
                                    gap: "5px",
                                    flexDirection: "column",
                                    justifyContent: "flex-end",
                                    alignItems: "flex-end"
                                }}>
                                    {!isRichTextEqual(newDescription, description) &&
                                        <ButtonBlue width={120} text={"Отменить"}
                                                    onClick={() => {
                                                        setNewDescription(description)
                                                    }}/>}
                                    <ButtonAdd
                                        height={44}
                                        loading={loading}
                                        text={"Изменить"}
                                        disabled={isRichTextEqual(newDescription, description)}
                                        onClick={handleDescription}/>
                                </Box>
                            </Box>
                        ) : null}
                    </>}
            </Box>
            {open && <ModalEditMaterial
                open={open}
                handleClose={handleClose}
                handleSubmit={handleSubmit}
                handleModalAlert={handleModalAlert}
                initValue={modalMaterialData}
                loading={loading}/>}
            <ModalAlert
                data={alertData}
                onClose={handleCloseAlert}/>
        </Box>
    )
}
export default ModulesItem